import React from 'react';
import { Link } from 'react-router-dom';
import Stats from '../components/Stats';

/**
 * @file
 * @module Pages/Dashboard
 * @description Dashboard est une page qui affiche le tableau de bord de l'administrateur.
 * - Elle contient des liens vers d'autres pages d'administration, comme la gestion des utilisateurs et la création d'une URL de création de compte.
 * - Elle contient également un lien vers le Back Office ReducCe.
 * - Cette page utilise le composant Stats pour afficher les statistiques de l'application.
 * 
 */

const Dashboard = () => {
    return (
        <div className="container-responsive section-padding">
            <div className="max-w-6xl mx-auto">
                <div className="card mb-8">
                    <h1 className="text-3xl font-bold text-primary mb-6">Bienvenue sur la page d'accueil de l'administrateur</h1>
                    
                    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                        <Link 
                            to="/admin/users" 
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-users"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Gérer les utilisateurs</h3>
                            <p className="text-gray-600 text-sm">Administrer les comptes utilisateurs</p>
                        </Link>
                        
                        <Link 
                            to="/admin/CreateSignupPage" 
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-user-plus"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Créer une URL de création de compte</h3>
                            <p className="text-gray-600 text-sm">Générer des liens d'inscription</p>
                        </Link>
                        
                        <a 
                            href="https://admin.reducce.fr/login?returnUrl=%2Fadministrators" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-cogs"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Back Office ReducCe</h3>
                            <p className="text-gray-600 text-sm">Administration ReducCe</p>
                        </a>
                        
                        <a 
                            href="https://app.brevo.com/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">App Brevo</h3>
                            <p className="text-gray-600 text-sm">Gestion des emails</p>
                        </a>
                        
                        <Link 
                            to="/adminBounces" 
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-exclamation-triangle"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Retour Brevo mail invalid</h3>
                            <p className="text-gray-600 text-sm">Gérer les bounces email</p>
                        </Link>
                        
                        <Link 
                            to="/commandes" 
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-shopping-cart"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Voir les commandes synchronisées</h3>
                            <p className="text-gray-600 text-sm">Suivi des commandes</p>
                        </Link>
                        
                        <Link 
                            to="/admin/connection-history" 
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-chart-line"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Historique des connexions</h3>
                            <p className="text-gray-600 text-sm">KPIs connexions sur 48 mois</p>
                        </Link>

                        <Link 
                            to="/admin/email-changes" 
                            className="card hover:shadow-xl transition-shadow duration-300 p-6 text-center group"
                        >
                            <div className="text-4xl mb-4 text-primary group-hover:text-primary-light transition-colors">
                                <i className="fas fa-exchange-alt"></i>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Changements d'email</h3>
                            <p className="text-gray-600 text-sm">Historique utilisateur et admin</p>
                        </Link>
                    </div>
                </div>

                <div className="card">
                    <Stats />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;